import React, { useState } from 'react'
import { ExpandMore, ExpandLess, AddOutlined, DoneOutlined } from '@mui/icons-material'
import { useStyles } from './style'
import {
  Typography,
  Divider,
  IconButton,
  Box,
  Chip,
  Button
} from '@mui/material'

const MAX_SELECTION_PER_CATEGORY = 5
const MAX_TOPIC_PER_CATEGORY = 8

const Dropdown = ({ title, optionList, selected, onChangeSelected, expand, handleExpand }) => {
  const classes = useStyles()

  const [end, setEnd] = useState(MAX_TOPIC_PER_CATEGORY)
  const subtitle = `${selected.length} of ${MAX_SELECTION_PER_CATEGORY} selected`

  const handleOnChange = (topic) => {
    const isSelected = selected.includes(topic)
    if (!isSelected && selected.length >= MAX_SELECTION_PER_CATEGORY) return
    if (isSelected) return onChangeSelected(selected.filter(t => t !== topic))
    return onChangeSelected([...selected, topic])
  }

  const handleLoadTopics = () => {
    setEnd(optionList.length)
  }

  return (
    <div>
      <div className={classes.title}>
        <div>
          <Typography>
            {title}
          </Typography>
          <Typography variant='caption'>
            {subtitle}
          </Typography>
        </div>

        {expand
          ? <IconButton onClick={handleExpand} size='large'> <ExpandLess /> </IconButton>
          : <IconButton onClick={handleExpand} size='large'> <ExpandMore /> </IconButton>}
      </div>

      <Divider />
      <Box component='div' display={expand ? 'flex' : 'none'} className={classes.topics}>
        <Box className={classes.root} data-test={`select-topic-container-${title.replace(' ', '-')}`}>
          {optionList.slice(0, end).map((topic, i) => {
            const isSelected = selected.includes(topic.sk)
            const color = isSelected ? 'primary' : 'default'
            const deleteIcon = isSelected ? <DoneOutlined /> : <AddOutlined />
            return (
              <Chip
                key={`${topic.sk}-${i}`}
                clickable
                label={topic.name}
                color={color}
                className={classes.topic}
                onClick={() => handleOnChange(topic.sk)}
                onDelete={() => handleOnChange(topic.sk)}
                deleteIcon={deleteIcon}
                data-test={`topic-chip-${topic.name}`}
              />
            )
          })}
        </Box>
        {optionList.length > 8 && end < optionList.length &&
          (<Button variant='outlined' onClick={handleLoadTopics} className={classes.load}>Load more topics</Button>)}
      </Box>
    </div>
  )
}
export default Dropdown
